export const CUSTOM_BACKEND_ERROR_CODES = {
	FORBIDDEN_ERR: 4003,
	UNAUTHORIZED_ERR: 4010,
	TOKEN_REVOKED_ERR: 4012,
	TOKEN_NOT_ACTIVE_ERR: 4013,
	EMAIL_NOT_VERIFIED_ERR: 4015,
	INVALID_EMAIL_OR_PASSWORD_OR_TYPE_ERR: 4028,
	INVALID_MFA_CODE_ERR: 4128,
	MFA_REQUIRED_ERR: 4228,
	TOKEN_VERIFICATION_ERR: 4328,
	UNPROCESSABLE_ENTITY: 4222,
	USER_IS_BLOCKED: 4291,
	INTERNAL_SERVER_ERR: 5000,
	INVALID_REQUEST: 6000,
} as const;
